import type { PlanId, PlanLimits } from "./api/types";

/**
 * Plan table, the same values as api/catalog/plans.py (design doc 1.4). Real numbers only;
 * prices are not decided yet. `null` means unlimited.
 */
export const PLANS: readonly PlanLimits[] = [
  {
    id: "free",
    name: "무료",
    pages: 1,
    monthly_drafts: 100,
    chip_edit: false,
    accent: false,
    hide_badge: false,
  },
  {
    id: "standard",
    name: "스탠다드",
    pages: 3,
    monthly_drafts: 1000,
    chip_edit: true,
    accent: false,
    hide_badge: false,
  },
  {
    id: "pro",
    name: "프로",
    pages: null,
    monthly_drafts: 10000,
    chip_edit: true,
    accent: true,
    hide_badge: true,
  },
  {
    id: "enterprise",
    name: "엔터프라이즈",
    pages: null,
    monthly_drafts: null,
    chip_edit: true,
    accent: true,
    hide_badge: true,
  },
];

export function planRow(id: string | null | undefined): PlanLimits {
  return PLANS.find((p) => p.id === id) ?? (PLANS[0] as PlanLimits);
}

/**
 * `/console/me` plan, or the business plan id when `plan` is null. Server values win; missing
 * fields come from the table (an unknown id falls back to free, like `get_plan`).
 */
export function normalizePlan(
  plan: Partial<PlanLimits> | null | undefined,
  businessPlan?: PlanId | string | null
): PlanLimits {
  const row = planRow(plan?.id ?? businessPlan);
  return {
    id: row.id,
    name: plan?.name ?? row.name,
    pages: plan?.pages !== undefined ? plan.pages : row.pages,
    monthly_drafts: plan?.monthly_drafts !== undefined ? plan.monthly_drafts : row.monthly_drafts,
    chip_edit: plan?.chip_edit ?? row.chip_edit,
    accent: plan?.accent ?? row.accent,
    hide_badge: plan?.hide_badge ?? row.hide_badge,
  };
}

export function formatCount(n: number | null): string {
  return n === null ? "무제한" : n.toLocaleString("ko-KR");
}
